import { render, staticRenderFns } from "./ConfimationForm.vue?vue&type=template&id=55ec19ca"
import script from "./ConfimationForm.vue?vue&type=script&lang=js"
export * from "./ConfimationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports